import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';
import { useSelector } from 'react-redux';
import cn from 'classnames';

const TableImport = ({ data, onDelete, onUpdate }) => {
  const StateForm = useSelector((state) => state?.Form);

  return (
    <div>
      <div className="bg-white py-md-3 px-3 border rounded-2">
        <div className="row">
          <div className="col-12">
            <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
              Daftar Layanan
            </div>

            <div className="table-responsive bg-white">
              <table
                width="100%"
                className="table table-hover table-vcenter card-table datatable border"
              >
                <thead className="bg-light">
                  <tr className="th">
                    <td>No</td>
                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        width: '30%',
                        textAlign: 'left',
                      }}
                    >
                      Service
                    </td>
                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        width: '40%',
                        textAlign: 'left',
                      }}
                    >
                      Nama Layanan
                    </td>
                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        width: '10%',
                        textAlign: 'left',
                      }}
                    >
                      Dividers
                    </td>
                    <td></td>
                  </tr>
                </thead>

                <tbody>
                  {data?.map((d, i) => (
                    <tr
                      key={i}
                      className={cn(
                        StateForm?.errors[`datas.${i}.service_id`] ||
                          StateForm?.errors[`datas.${i}.name`]
                          ? 'border-danger border-bottom'
                          : null
                      )}
                    >
                      <td>{i + 1}</td>
                      <td style={{ whiteSpace: 'nowrap', width: '15%' }}>
                        {d?.service?.name}

                        {StateForm?.errors[`datas.${i}.service_id`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.service_id`]}
                          </div>
                        ) : null}
                      </td>
                      <td style={{ whiteSpace: 'nowrap', width: '15%' }}>
                        {d?.name}

                        {StateForm?.errors[`datas.${i}.name`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.name`]}
                          </div>
                        ) : null}
                      </td>
                      <td style={{ whiteSpace: 'nowrap', width: '15%' }}>
                        {d?.service?.id === '61bb02262a457fc68763b774' ? d?.dividers : '-'}
                      </td>
                      <td className="text-end">
                        <div
                          className="btn-toolbar justify-content-end"
                          role="toolbar"
                        >
                          <div className="btn-group" role="group">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>
                              }
                            >
                              <button
                                type="button"
                                onClick={() => onUpdate(d, i)}
                                className="btn btn-ghost-primary px-2"
                              >
                                <Fi.FiEdit size={17} />
                              </button>
                            </OverlayTrigger>

                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id={`tooltip-top`}>Hapus</Tooltip>
                              }
                            >
                              <button
                                type="button"
                                onClick={() => onDelete(i)}
                                className="btn btn-ghost-danger px-2"
                              >
                                <Fi.FiTrash2 size={17} />
                              </button>
                            </OverlayTrigger>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableImport;
